// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { PFixFieldSet } from '../Fields/FieldsImport';
import { FieldsFactory } from '../Factory/FieldsFactory';
export class MarginPFixGroup extends PFixFieldSet {
    get isAllowOTHTrading() {
        return this.GetValue(FieldsFactory.FIELD_ALLOW_OTH_TRADING);
    }
    set isAllowOTHTrading(value) {
        if (!isNullOrUndefined(value)) {
            this.SetField(FieldsFactory.FIELD_ALLOW_OTH_TRADING, value);
        }
    }
    constructor(pfixFieldSet) {
        super(FieldsFactory.MARGIN_GROUP, null, pfixFieldSet);
    }
    getId() {
        return this.GetValue(FieldsFactory.FIELD_ID);
    }
    setId(id) {
        this.SetField(FieldsFactory.FIELD_ID, id);
    }
    setAccountId(accountId) {
        this.SetField(FieldsFactory.FIELD_ACCOUNT_ID, accountId);
    }
    setTradableInstrumentID(insID) {
        this.SetField(FieldsFactory.FIELD_TRADABLE_INSTRUMENT_ID, insID);
    }
    setRouteId(routeId) {
        this.SetField(FieldsFactory.FIELD_ROUTE_ID, routeId);
    }
    setAmount(amount) {
        this.SetField(FieldsFactory.FIELD_AMOUNT, amount);
    }
    setCashOrderQty(cash) {
        this.SetField(FieldsFactory.FIELD_CASH_ORDER_QTY, cash);
    }
    setPrice(price) {
        this.SetField(FieldsFactory.FIELD_PRICE, price);
    }
    setStopPrice(price) {
        this.SetField(FieldsFactory.FIELD_STOP_PRICE, price);
    }
    setOrderType(orderType) {
        this.SetField(FieldsFactory.FIELD_ORDER_TYPE, orderType);
    }
    setValidity(validity) {
        this.SetField(FieldsFactory.FIELD_VALIDITY, validity.type);
    }
    setOperationMode(operationMode) {
        this.SetField(FieldsFactory.FIELD_OPERATION_MODE, operationMode);
    }
    setMarginMode(marginMode) {
        this.SetField(FieldsFactory.FIELD_MARGIN_MODE, marginMode);
    }
    setProductType(productType) {
        this.SetField(FieldsFactory.FIELD_PRODUCT_TYPE, productType);
    }
    setLeverage(setLeverage) {
        this.SetField(FieldsFactory.FIELD_LEVERAGE_SHORT, setLeverage);
    }
}
